module.exports = __webpack_public_path__ + "static/step-bg.abfbdf9f.png";